/**
 * @ngdoc directive
 * @name drvEmailFromEntitySelector
 * 
 * @description
 * Used for selecting what entities the email will be associated with to perform a send operation. These provide the default from address and
 * the entity data to be used with merge fields.
 */

(function () {
    'use strict';

    angular
        .module('app')
        .directive('drvEmailFromEntitySelector', drvEmailFromEntitySelector);

    drvEmailFromEntitySelector.$inject = [];

    function drvEmailFromEntitySelector() {
        var directive = {
            restrict: 'E',
            scope: {},
            controller: drvEmailFromEntitySelectorCtrl,
            controllerAs: 'drvCtrl',
            bindToController: {
                multiMode: '<',
                emailContacts: '=',
                entityTemplate: '<'
            },
            template:
                '<div ng-if="!drvCtrl.loading">'+
                '   <div ng-if="drvCtrl.multiMode">' +
                '      <drv-entity-linked-many-input ng-model="drvCtrl.internalValue" field="drvCtrl.fieldDetails" entity-template="drvCtrl.entityTemplate"></drv-entity-linked-many-input>' +
                '   </div>' +
                '   <div ng-if="!drvCtrl.multiMode">' +
                '      <drv-entity-linked-single ng-model="drvCtrl.internalValue" field="drvCtrl.fieldDetails" flex="90"></drv-entity-linked-single>' +
                '   </div>' +
                '</div>'
        };

        drvEmailFromEntitySelectorCtrl.$inject = ['$scope'];

        return directive;

        function drvEmailFromEntitySelectorCtrl($scope) {
            /* jshint validthis:true */
            var drvCtrl = this;

            activate();

            function activate() {
                updateInternalValue();
                drvCtrl.fieldDetails = { EntityTemplateId: drvCtrl.entityTemplate.Id, DisableFullClear: true };

                if (drvCtrl.multiMode) {
                    drvCtrl.fieldDetails.Name = drvCtrl.entityTemplate.PluralName;
                } else {
                    drvCtrl.fieldDetails.Name = drvCtrl.entityTemplate.Name;
                }

                $scope.$watch('drvCtrl.internalValue', function (newVal, oldVal) {
                    if (newVal !== oldVal) {
                        updateEmailContacts();
                    }
                }, true);

                $scope.$watch('drvCtrl.emailContacts', function (newVal, oldVal) {
                    if (newVal !== oldVal) {
                        updateInternalValue();
                    }
                }, true);
            }

            function updateInternalValue() {
                var newInternalValue = null;

                if (drvCtrl.multiMode) {
                    newInternalValue = [];
                    angular.forEach(drvCtrl.emailContacts, function (contact) { newInternalValue.push(contact.EntityDetails.Id); });
                } else {
                    var id = null;
                    if (!_.isNil(drvCtrl.emailContacts[0])) {
                        id = drvCtrl.emailContacts[0].EntityDetails.Id;
                    }
                    newInternalValue = id;
                }

                if (!angular.equals(newInternalValue, drvCtrl.internalValue)) {
                    drvCtrl.internalValue = newInternalValue;
                }
            }

            function updateEmailContacts() {
                var newEmailContacts = null;

                if (drvCtrl.multiMode) {
                    newEmailContacts = [];
                    angular.forEach(drvCtrl.internalValue, function (value) { newEmailContacts.push({ EntityDetails: { Id: value } }); });
                } else {
                    newEmailContacts = [{ EntityDetails: { Id: drvCtrl.internalValue } }];
                }

                if (!angular.equals(newEmailContacts, drvCtrl.emailContacts)) {
                    drvCtrl.emailContacts = newEmailContacts;
                }
            }
        }
    }
})();